<template>
  <td class="plan-table__data quotaValue">
    {{ quota.value }}
  </td>
</template>

<script>
import { quotaTypes } from '@/enums';

export default {
  name: 'PaymentPlanQuotaItem',
  props: {
    quota: {
      type: Object,
      required: true,
    },
  },
  setup() {
    return {
      quotaTypes,
    };
  },
};
</script>

<style lang="scss" scoped>

</style>

<i18n lang="yml" locale="ru">
  once: Единоразово
  interviews: Отклики
  sms: SMS
  calls: Звонки
</i18n>
<i18n lang="yml" locale="en">
  once: once
  interviews: Interviews
  sms: Text messages
  calls: Calls
  price: Price per month
</i18n>
